import { RolesStore } from './RolesStore';
import { RolesStoreAll } from './RolesStoreAll';
import { RolesStoreOrganization } from './RolesStoreOrganization';

export default {
    rolesStore: new RolesStore(),
    rolesStoreAll: new RolesStoreAll(),
    rolesStoreOrganization: new RolesStoreOrganization()
};
